import { render, staticRenderFns } from "./SupplierSettlementView.vue?vue&type=template&id=347407ec&scoped=true"
import script from "./SupplierSettlementView.vue?vue&type=script&lang=js"
export * from "./SupplierSettlementView.vue?vue&type=script&lang=js"
import style0 from "./SupplierSettlementView.vue?vue&type=style&index=0&id=347407ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347407ec",
  null
  
)

export default component.exports